export const themeColors = {
  // Primary colors
  Primary: '#0033A0',
  PrimaryAccent: '#45BCE5',
  Secondary: '#FF9E16',
  Quaternary: '#F79EA4',
  AllstatePink: '#D33195',
  AllstateGreen: '#95D600',

  // Primary whites and blues
  primaryWhite: '#fff',
  primaryBlack: '#000',
  blue_25T: '#e1eaff2d',
  blue_50T: '#e0e8fb4c',
  blue_50: '#f4f7fe',
  blue_70: '#eaf0fe',
  blue_100: '#e1eaff',
  blue_200: '#82a1d1',
  blue_400: '#004ea8',
  blue_500: '#173e82',
  blue_600: '#012f64',

  // Secondary bright blues
  brightBlue_100: '#d6efff',
  brightBlue_200: '#9cd3ff',
  brightBlue_300: '#2fa0ff',
  brightBlue_400: '#0f86ef',
  brightBlue_500: '#006cca',
  brightBlue_600: '#0058a9',

  // Purple colors
  purple_100: '#d5d4ee',
  purple_200: '#c0bae8',
  purple_300: '#a49fe8',
  purple_500: '#612f93',
  purple_700: '#221551',

  // Gray colors
  gray_30: '#fcfbfd',
  gray_50: '#faf9fb',
  gray_50T: '#dedaf52d',
  gray_70: '#f3f2f7',
  gray_70T: '#b9b8d62d',
  gray_100: '#e2e4e8',
  gray_100T: '#6c6c7d2d',
  gray_300: '#b7b8be',
  gray_400: '#8a8b91',
  gray_500: '#6d7179',
  gray_700: '#505054',
  gray_800: '#424245',

  // Accent colors
  pink_500: '#f72094',

  // Semantic colors - SUCCESS
  green_50: '#edf6eb',
  green_100: '#dcedd7',
  green_300: '#50863a',
  green_500: '#006b00',

  // Semantic colors - WARNING
  red_25: '#fff1f1',
  red_50: '#ffe0e1',
  red_100: '#ffb1b2',
  red_300: '#f3797a',
  red_500: '#dc3038',
  red_600: '#c62b32',

  // Semantic colors - ATTENTION
  orange_100: '#ffdaa2',
  orange_300: '#ed7002',
  orange_500: '#d93a00',

  // Yellow colors
  yellow_25: '#fffbf1',
  yellow_50: '#fff9e7',
  yellow_100: '#ffeebd',
  yellow_300: '#ffe06a',
  yellow_500: '#ffd200',

  // Background colors
  app_bg: '#EEF2FB',
  main_bg: '#f1f1f1',
} as const;

